<template>
    <div class="responsibles">

        <box-helper
            headline="Ansvarlige"
            identifier="responsibles"
            v-if="$auth.user().roles[0].name !== 'project-responsible'"
        />

        <div class="container section">
            <title-block headline="<b>Ansvarlige</b>" class="mb-xl" position="center" v-if="$auth.user().roles[0].name !== 'project-responsible'">
                <p slot="text">
                    Ét samlet overblik over dine ansvarlige
                </p>
            </title-block>

            <!--<view-toggle
                operationsName="Drift"
                operationsLink="EmployeesOperations"
                learningName="Udvikling / læring"
                learningLink="EmployeesLearning"
                v-if="$route.name === 'EmployeesOperations'"
            />-->

            <content-switch
                :items="switchItems"
                :selectedItem="selectedItem"
                :counts="counts"
                @selectItem="handleSelectItem($event)"
                v-if="$auth.user().roles[0].name !== 'project-responsible'"
            />

            <compare-responsible-employees v-show="selectedItem === 'compareResponsibleEmployees'"></compare-responsible-employees>

            <compare-project-types-for-responsibles v-show="selectedItem === 'compareProjectTypesForResponsibles'"></compare-project-types-for-responsibles>

            <responsible-valuechain v-show="selectedItem === 'responsibleValuechain'"></responsible-valuechain>
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedItem: 'compareResponsibleEmployees',
            counts: {},
            switchItems: [
                {
                    name: 'Hvilke ansvarlige er gode til hvilke opgaver?',
                    slug: 'compareResponsibleEmployees'
                },
                {
                    name: 'Hvilke opgavetyper er den enkelte ansvarlige god til?',
                    slug: 'compareProjectTypesForResponsibles'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$auth.user().roles[0].name === 'project-responsible') {
            this.selectedItem = 'responsibleValuechain'
        }
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        // if (this.$auth.user().roles[0].name === 'super-admin') {
            this.switchItems.push({
                name: 'Hvordan er de ansvarliges værdikæder?',
                slug: 'responsibleValuechain'
            })
        // }
    },
    components: {
        'compare-responsible-employees': require('./learning/compareResponsibleEmployees.vue'),
        'compare-project-types-for-responsibles': require('./learning/compareProjectTypesForResponsibles.vue'),
        'responsible-valuechain': require('./learning/responsibleValuechain.vue')
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?3ed51a84